import {useQuery, gql} from "@apollo/client";
var  PRODUCT_CATEGORY = gql`
query ProductCategory {
  productCategory(where: {localization: {culture_starts_with: "fa"}}) {
    id
    displayText
    description
    alias {
      alias
    }
    childrenCategories {
      contentItems {
        ... on ProductCategory {
          id
          displayText
          description
          alias {
            alias
          }
          childrenCategories {
            contentItems {
              ... on ProductCategory {
                id
                displayText
                description
                alias {
                  alias
                }
              }
            }
          }
          
        }
      }
    }
    
  }
}

  `;

export const useProductCategory = () => {
  const {error, loading, data} = useQuery(PRODUCT_CATEGORY);
  
  return {
    error, data, loading
  };
  } 